@if (item.dietary && (item.dietary.airborne_allergy || item.dietary.religious_or_lifestyle)) {
  <div class="flex flex-wrap gap-1 py-1">
    @for (flag of flags; track flag.key) {
      @if (isVisible(flag.key)) {
        <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="flag.classes">
          {{ flag.label }}
        </span>
      }
    }
  </div>
} @else {
  <span>—</span>
}
